import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import s from "./styles.scss";

export interface TableProps {
  data: any[];
  loading: boolean;
}

export const MemoTable = React.memo(({ data, loading }: TableProps) => {
  const [checkAll, setCheckAll] = useState(false);
  const [columns, setColumns] = useState(columnsFormatter());

  useEffect(() => {
    setColumns(columnsFormatter());
  }, []);

  useEffect(() => {
    checkAll && setCheckAll(false);
  }, [data]);

  return (
    <>
      <div className="row mt-4">
        <div style={{ width: "100%", overflowX: "hidden" }}>
          <ReactTable
            data={data || []}
            loading={loading}
            pageSize={data && data.length > 5 ? data.length : 5}
            columns={columns}
            sortable={false}
            resizable={false}
            showPagination={false}
            className={`w-100 -highlight -striped ${s.hidden}`}
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </>
  );
});

const columnsFormatter = () => [
  {
    Header: "Fecha",
    id: "eventoFecha",
    width: 128,
    className: s.tdClear,
    accessor: dateAccessor("eventoFecha")
  },
  {
    Header: "Descripción",
    id: "actividad",
    className: s.tdClear,
    accessor: actividadAccessor()
  },
  {
    Header: "Usuario",
    id: "eventoUsername",
    width: 144,
    className: s.tdClear,
    accessor: userAccessor()
  },
  {
    Header: "Nombre",
    id: "eventoUserFullName",
    width: 255,
    className: s.tdClear,
    accessor: nameAccessor()
  }
];

function fieldClassName() {
  return s.field;
}

function userAccessor() {
  return (row: any) => {
    const isSystem =
      !row.eventoUserId || row.eventoUserId == -1 || row.eventoUserId == -2;
    const value = isSystem ? "sistema" : row.eventoUsername;
    return <div className={fieldClassName()}>{value}&nbsp;</div>;
  };
}

function nameAccessor() {
  return (row: any) => {
    const isSystem =
      !row.eventoUserId || row.eventoUserId == -1 || row.eventoUserId == -2;
    let value = isSystem ? "USUARIO GLOBAL DE SISTEMA" : row.eventoUserFullName;
    if (value && (value as any).toUpperCase) {
      value = (value as string).toUpperCase();
    }
    return <div className={fieldClassName()}>{value}&nbsp;</div>;
  };
}

function actividadAccessor() {
  return (row: any) => {
    let value = row.actividad || "";
    if (row.modulo == "ARCHIVOS" && row.json) {
      try {
        const json = JSON.parse(row.json);
        const archivo = json && json.nombre ? ` (${json.nombre})` : "";
        value = `${value}${archivo}`;
      } catch (e) {}
    }
    return (
      <div
        className={fieldClassName()}
        style={{ whiteSpace: "normal", wordBreak: "break-word" }}
      >
        {value}&nbsp;
      </div>
    );
  };
}

function dateAccessor(key: string) {
  return row => {
    return (
      <div className={fieldClassName()}>{formatDate(row[key] || "-")}</div>
    );
  };
}

function formatDate(isoDate: string): string {
  if (!isoDate || isoDate == "-") {
    return "-";
  }

  try {
    const [date, time] = isoDate.split("T");
    const [year, month, day] = date.split("-");
    const fmtDate = `${day}/${month}/${year} `;
    const indexSeconds = time.lastIndexOf(":");
    const fmtTime = indexSeconds >= 4 ? time.substring(0, indexSeconds) : time;
    return fmtDate + fmtTime;
  } catch (error) {
    return isoDate;
  }
}
